import { useState } from "react";
import { createFromIconfontCN } from "@ant-design/icons";
import { BackTop, Modal, Input, Form, Button, message, Dropdown, Menu } from "antd";
import codeImg from "@/image/code.png";
import customer from "@/assets/customer.png";
import earth from "@/assets/earth.png";
import feedBack from "@/assets/feedBack.png";
import { messageModal } from "@utils/message-modal";
import "./index.less";
import { feedback } from "@/services/auth";
//语言切换
import intl from "react-intl-universal";
const { TextArea } = Input;

const IconFont = createFromIconfontCN({
  scriptUrl: [process.env.REACT_APP_ICON],
});

const CustomerFeedback = () => {
  const [modal, setModal] = useState(false);
  const [form] = Form.useForm();

  //中英文语言栏
  const langTypeMenu = (
    <Menu
      className="special-menu"
      onClick={(p) => {
        if (p.key !== localStorage.getItem("language_type")) {
          localStorage.setItem("language_type", p.key);
          const date = new Date("Fri, 31 Dec 9999 23:59:59 GMT");
          document.cookie = 'languageType=' + p.key + "; expires=" + date.toUTCString() + ";path=/;domain=.dataoceanai.com";
          window.location.reload(); //点击后刷新，这样state里的代码会再次执行，从而达到切换效果
        }
      }}
    >
      <Menu.Item key="zh_CN">zh_CN&nbsp;简体中文</Menu.Item>
      <Menu.Item key="en_US">en_US&nbsp;Engilsh</Menu.Item>
    </Menu>
  );

  // 提交
  const submit = (values) => {
    const { phone, email } = values;
    if (!phone && !email) {
      messageModal(
        intl.get(
          "Must_enter_at_least_one_of_phone_number_and_Email_966814b7-4a9f-21cb-919e-83a7b2b8c36f"
        )
      );
      return;
    }
    feedback(values).then((res) => {
      if (res.code === 0) {
        message.success(
          intl.get("Submission_successful_8cca0fb3-4c43-2b74-893b-eddf070856fa")
        );
        form.resetFields();
        setModal(false);
      } else {
        message.error(res.message);
      }
    });
  };

  return (
    <div className="cf">
      <div className="box">
        <img className="icon" src={customer} />
        <span className="box-name">
          {intl.get("Customer_service_f1a55caa-77f3-21ec-b8c8-7dfe52ae4641")}
        </span>
        <div className="hover-box hover-serve">
          <img src={codeImg} alt="" />
          <div>
            {intl.get("Scan_83a3d9c5-5930-24ec-a293-25b449399e22_Scan")}
          </div>
        </div>
      </div>
      <div className="box">
        <div>
          <Dropdown
            overlay={langTypeMenu}
            trigger={["click"]}
            className="inline-block pointer"
          >
            <span>
              <img className="icon" src={earth} />
            </span>
          </Dropdown>
        </div>
        <span className="box-name">{intl.get("78a9ad89-be95-2ebe-90bf-c1cdc712d0f5")}</span>
      </div>
      <div
        className="box"
        onClick={() => {
          setModal(true);
        }}
      >
        <img className="icon" src={feedBack} />
        <span className="box-name">
          {intl.get("Feedback_6e7a2b5d-3612-2ca0-a0ff-3c9708685e49")}
        </span>
      </div>
      <BackTop>
        <IconFont type="icon-fanhuidingbu1" />
        <span className="box-name">
          {intl.get("Top_172f1ac9-c854-2903-b709-c6f88455fa9c")}
        </span>
      </BackTop>
      <Modal
        title={intl.get("Report_Issue_b531f551-9d61-2f83-9863-edd3d66a96cc")}
        visible={modal}
        onCancel={() => {
          setModal(false);
          form.resetFields();
        }}
        className="feedback-message"
        centered
        maskClosable={false}
        footer={[]}
      >
        <Form form={form} onFinish={submit}>
          <Form.Item
            name="content"
            rules={[
              {
                required: true,
                message: intl.get(
                  "Encountered_691bf798-97c0-2fdd-b0a8-4c1ec042bba5_Encountered"
                ),
              },
              {
                min: 20,
                type: "string",
                message: intl.get(
                  "No_less_than_characters_453093a0-a06f-2699-be52-04b05c2e20af"
                ),
              },
            ]}
          >
            <TextArea
              className="text"
              maxLength={200}
              showCount={true}
              placeholder={intl.get(
                "Encountered_691bf798-97c0-2fdd-b0a8-4c1ec042bba5_Encountered"
              )}
            />
          </Form.Item>
          <Form.Item
            name="phone"
            label={intl.get("Mobile_920ec331-509b-2b82-a7c7-c69407362189")}
            className="special"
            rules={[
              {
                pattern: new RegExp(/^1[0-9]{10}$/),
                message: intl.get(
                  "Invalid_phone_number_01fd94c3-e1e8-20da-8054-58d9ba28b44f"
                ),
              },
            ]}
          >
            <Input
              placeholder={intl.get(
                "Please_input_c3e58513-2767-2b92-94e8-996b2e50acb5"
              )}
            />
          </Form.Item>
          <Form.Item
            name="email"
            label={intl.get("Email_03a01916-5c4c-23c9-b215-c771a16d8a68")}
            className="special"
            rules={[
              {
                pattern: new RegExp(
                  /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
                ),
                message: intl.get(
                  "Invalid_email_address_2c0b7b0d-7faa-215b-abaf-aded55258b18"
                ),
              },
            ]}
          >
            <Input
              placeholder={intl.get(
                "Please_input_c3e58513-2767-2b92-94e8-996b2e50acb5"
              )}
            />
          </Form.Item>
          <Form.Item className="forget-password-buttonGroup">
            <Button type="primary" htmlType="submit">
              {intl.get("Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default CustomerFeedback;
